<template>
  <b-button class="smButton8 buttonColor">{{ text }}</b-button>
</template>

<script>
export default {
  name: "BasicButtonLong",
  props: ["text"],
};
</script>
